import { render } from "./course-categories.vue?vue&type=template&id=d63c1cdc&scoped=true"
import script from "./course-categories.vue?vue&type=script&lang=js"
export * from "./course-categories.vue?vue&type=script&lang=js"

import "./course-categories.vue?vue&type=style&index=0&id=d63c1cdc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d63c1cdc"]])

export default __exports__